const getKeyOfFirstTrue = o => {
    const found = Object.entries(o).find(([k, v]) => v === true);
    return found ? found[0] : null;
};

export default getKeyOfFirstTrue;
